/**
 * Sanitize attachments array for Firestore compatibility
 * Removes null/undefined values and ensures all attachment objects are valid
 * @param {Array} attachments - Array of attachment objects
 * @returns {Array} - Sanitized array safe for Firestore
 */
export function sanitizeAttachments(attachments) {
    if (!Array.isArray(attachments)) return [];

    // Clean objects and remove undefined properties
    const cleaned = attachments
        .filter(att => att != null && typeof att === 'object')
        .map(att => {
            const cleanAtt = { ...att };
            Object.keys(cleanAtt).forEach(key => {
                if (cleanAtt[key] === undefined) delete cleanAtt[key];
            });
            return cleanAtt;
        })
        .filter(att => Object.keys(att).length > 0);

    // Enforce attachment contract strictly. Only keep attachments that meet the contract.
    const valid = cleaned.filter(att => {
        if (!att) return false;
        if (typeof att.attachmentId !== 'string' || att.attachmentId.length === 0) return false;
        if (typeof att.filename !== 'string' || att.filename.length === 0) return false;
        if (typeof att.mimeType !== 'string' || att.mimeType.length === 0) return false;
        if (typeof att.storagePath !== 'string' || att.storagePath.length === 0) return false;
        if (typeof att.size !== 'number' || Number.isNaN(att.size)) return false;
        return true;
    });

    return valid;
}